import React, { useState, useContext } from 'react';
import { Col, Row, Form, Modal } from 'react-bootstrap';

import { AuthContext } from '../../context/AuthContext';
import { useHttp } from '../../hooks/http.hook';

export const TempPasswordGeneratorBlock = ({ user, setReceivedError }) => {
    const { token } = useContext(AuthContext);
    const { request, loading } = useHttp();

    const [passwordGeneratorUpdateForm, setPasswordGeneratorUpdateForm] = useState({ amount: 1, timeLimit: 3600 });
    const [passwordsList, setPasswordsList] = useState([]);

    const updatePasswordGeneratorHandler = (key, val) => {
        setPasswordGeneratorUpdateForm(
            passwordGeneratorUpdateForm => ({ ...passwordGeneratorUpdateForm, [key]: val }),
        );
    }

    const generatePassword = async () => {
        try {
            const data = await request(`/user/${user.id}/generate-temp-passwords`, 'POST', passwordGeneratorUpdateForm, {
                'x-access-token': token
            })

            if (data.changed && data.changed > 0) {
                // alert(`Generated ${data.changed} passwords`)
                fetchPasswords();
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const fetchPasswords = async () => {
        try {
            const fetched = await request(`/user/${user.id}/temp-passwords`, 'GET', null, {
                'x-access-token': token
            })

            if (fetched.passwords) {
                setPasswordsList(fetched.passwords);
            }

        } catch (e) {
            setReceivedError(e);
        }
    };

    const handlePasswordsModalClose = () => {
        setPasswordsList([]);
    };

    return (
        <>
            <h6 className="FormSubTitle mb-2 mt-5">Temporary Password Generator</h6>
            <Form className="my-2 ">
                <Row className="d-flex align-items-center">
                    <Col>
                        <Form.Label className="FormText">Amount</Form.Label>
                        <Form.Control min={1} type="number" name="amount" className="FormTextDark BoxShadow" style={{ fontWeight: "200" }}
                            placeholder="Enter amount of passwords"
                            onChange={e => updatePasswordGeneratorHandler('amount', e.target.value)} />
                    </Col>
                    <Col>
                        <Form.Label className="FormText">Time Limit</Form.Label>
                        <Form.Control as="select" custom
                            onChange={(e) => {
                                updatePasswordGeneratorHandler('timeLimit', e.target.value);
                            }
                            }
                            className="FormTextDark BoxShadow" style={{
                                minWidth: '75px',
                                fontWeight: "200"
                            }}>
                            <option value="3600" className="FormTextDark">1 Hour</option>
                            <option value="18000" className="FormTextDark">5 Hours</option>
                            <option value="43200" className="FormTextDark">12 Hours</option>
                            <option value="86400" className="FormTextDark">24 Hours</option>
                            <option value="172800" className="FormTextDark">2 Days</option>
                            <option value="432000" className="FormTextDark">5 Days</option>
                            <option value="604800" className="FormTextDark">7 Days</option>
                        </Form.Control>
                    </Col>
                    <Col className="align-self-end d-flex">
                        <button type="submit" className="ElementButton SmallInputText" disabled={loading}
                            onClick={(e) => {
                                e.preventDefault();
                                generatePassword();
                            }}>
                            Generate
                        </button>

                        <button disabled={loading} className="ElementButton SmallInputText mx-2" onClick={() => fetchPasswords()}>
                            Show
                        </button>
                    </Col>
                </Row>
            </Form>

            <Modal show={!!passwordsList.length} onHide={handlePasswordsModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="FormTextDark">Unused temporary passwords</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="FormTextDark mb-2">Login - {user.email}</div>
                    <table className="w-50">
                        <thead>
                            <tr>
                                <th className="FormTextDark">Password</th>
                                <th className="FormTextDark">Time Limit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {passwordsList.map((password_item, index) =>
                                <tr key={index}>
                                    <td className="FormTextDark">{password_item.password}</td>
                                    <td className="FormTextDark">{password_item.time_limit}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </Modal.Body>
            </Modal>
        </>
    );
}
